import { render, staticRenderFns } from "./partner.vue?vue&type=template&id=926aab14"
import script from "./partner.vue?vue&type=script&lang=js"
export * from "./partner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('926aab14')) {
      api.createRecord('926aab14', component.options)
    } else {
      api.reload('926aab14', component.options)
    }
    module.hot.accept("./partner.vue?vue&type=template&id=926aab14", function () {
      api.rerender('926aab14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/users/partner.vue"
export default component.exports